<template>
  <Drawer
    width="400"
    :title="`${openedSales ? '编辑' : '新增'}销售记录`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="内容" prop="content">
          <Input
            v-model="formItem.content"
            type="textarea"
            show-word-limit
            :rows="6"
            maxlength="200"
            placeholder="在此填写销售记录..."
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateSalesDrawer",
  data() {
    return {
      drawerOpened: false,
      type: null,
      openedSales: null,
      customerLoading: false,
      productList: [],
      formItem: {
        customer: null,
        content: null,
      },
      ruleValidate: {
        customer: [
          { required: true, message: "名字为必填项", trigger: "submit" },
        ],
        content: [
          {
            required: true,
            message: "销售记录内容为必填项",
            trigger: "submit",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions({
      createSalesRecord: "salesRecord/createSalesRecordAction",
      updateSalesRecord: "salesRecord/updateSalesRecordAction",
    }),
    async remoteMethod(query) {
      if (query !== "") {
        this.customerLoading = true;
        await this.getCustomers({ searchText: query });
        this.customerLoading = false;
      }
    },
    async openDrawer(customerId, salesRecord) {
      this.$refs["formItem"].resetFields();
      this.formItem.customer = customerId;
      this.openedSales = salesRecord; // 如果有打开，则为编辑模式
      if (salesRecord) {
        this.formItem.content = salesRecord.content;
      }
      this.drawerOpened = true;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSales) {
              await this.updateSalesRecord({
                id: this.openedSales._id,
                data: this.formItem,
              });
            } else {
              await this.createSalesRecord(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus"></style>
